import type { CSSProperties } from 'react'
import type { SxProps, Theme } from '@mui/material/styles'

type ProfileLayoutStyleMap = {
    layoutContainer: SxProps<Theme>
    sidebarContainer: SxProps<Theme>
    sidebarList: SxProps<Theme>
    sidebarItemIcon: SxProps<Theme>
    contentContainer: SxProps<Theme>
    mobileTabsContainer: SxProps<Theme>
    mobileTabs: SxProps<Theme>
    mobileTabLabel: SxProps<Theme>
}

export const profileLayoutStyles: ProfileLayoutStyleMap = {
    layoutContainer: { display: 'flex', gap: 3, alignItems: 'flex-start' },
    sidebarContainer: { width: 220, flexShrink: 0, display: { xs: 'none', sm: 'block' } },
    sidebarList: { bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    sidebarItemIcon: { minWidth: 36 },
    contentContainer: { flex: 1, minWidth: 0 },
    mobileTabsContainer: { display: { xs: 'block', sm: 'none' }, mb: 3 },
    mobileTabs: { bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 2 },
    mobileTabLabel: { display: 'flex', alignItems: 'center', gap: 0.75 },
}

export const getProfileSidebarItemButtonStyles = (): SxProps<Theme> => ({
    py: 1.5,
    '&.Mui-selected': {
        bgcolor: 'primary.50',
        color: 'primary.main',
        '& .MuiListItemIcon-root': { color: 'primary.main' },
        '&:hover': { bgcolor: 'primary.50' },
    },
})

export const getProfileMobileTabStyles = (): SxProps<Theme> => ({
    textTransform: 'none',
    fontSize: 14,
})

export const getProfileTabIndicatorStyle = (theme: Theme): CSSProperties => ({
    backgroundColor: theme.palette.primary.main,
})
